import { render, staticRenderFns } from "./Weeklies.vue?vue&type=template&id=7bfa3be3&"
import script from "./Weeklies.vue?vue&type=script&lang=js&"
export * from "./Weeklies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports